// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0eea932a","466":"235cbe0e","533":"3b89e139","621":"2629eb00","692":"13ff7a7d","711":"61a7261f","873":"7126ac15","879":"faecce79","881":"2fcd8969","930":"0baee5f9"}[chunkId] + ".chunk.js";
};